import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'
import Dropdown from '../misc/Dropdown'
import Breadcrumbs from '../displays/Breadcrumbs'

const icons = {
  'inventory': 'fa-cubes',
  'flow': 'fa-home',
  'access': 'fa-home',
  'address': 'fa-map',
  'event': 'fa-sliders',
  'administration': 'fa-gear',
  'configuration': 'fa-wrench',
  'service': 'fa-suitcase',
  'customer': 'fa-address-book',
  'catalogue': 'fa-book',
  'ticket': 'fa-ticket'
}
class ContentHeader extends Component {
  render () {
    ReactTooltip.rebuild()
    return (
      <div className='content-header clearfix'>
        <ReactTooltip effect='solid' place='top' type='dark' />
        <div className='row'>
          <div className='col-md-6'>
            <div className='breadcrumbs'>
              <h4><i className={'fa ' + (this.props.icon ? this.props.icon : icons[window.location.hash.split('/')[1]])} />{this.props.title} <small> {this.props.subtitle}</small></h4>
            </div>
          </div>
          <div className='col-md-6 pull-right'>
            <div className={'content-header-buttons pull-right ' + (this.props.buttons ? '' : ' hidden')}>
              {this.props.buttons && this.props.buttons.map((button) => {
                if (button.hidden) return null
                if (button.dropdown) {
                  return (
                    <Dropdown links={button.links} icon={button.icon} />
                  )
                }
                return (
                  <a href={button.href} target={(button.blank ? '_blank' : '')} key={Date.now() + Math.random()} onClick={button.event} data-tip={button.tip} className='box-button pull-left'><i className={'fa fa-fw ' + button.icon} /></a>
                )
              })}
            </div>
          </div>
          <div className='col-md-12'>
            {this.props.breadcrumbs && <Breadcrumbs links={this.props.breadcrumbs} />}
          </div>
        </div>
      </div>
    )
  }
}
export default ContentHeader



// WEBPACK FOOTER //
// ./src/components/basic/containers/ContentHeader.js